import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import App from "./App";
import { store } from "./store";
import {
  GoogleReCaptcha,
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";
import ReduxToastr from "react-redux-toastr";
import { AuthWrapper } from "./hooks/AuthWrapper";


const root = ReactDOM.createRoot(document.getElementById("root")!);

const recaptchaKey = import.meta.env.VITE_PUBLIC_APP_RECAPCHA || "6LfPjkMnAAAAAKW5h-7VKqIl61_4bKBhdupUHvXm";
root.render(
  <React.StrictMode>
    <AuthWrapper>
      <Provider store={store}>
        <BrowserRouter>
          <GoogleReCaptchaProvider
            reCaptchaKey={recaptchaKey}
            scriptProps={{
              async: true,
              defer: true,
              appendTo: "head",
              nonce: undefined,
            }}
          >
            <App />
            <ReduxToastr
              timeOut={4000}
              newestOnTop={false}
              preventDuplicates
              position="top-right"
              transitionIn="fadeIn"
              transitionOut="fadeOut"
              progressBar
              closeOnToastrClick
            />
          </GoogleReCaptchaProvider>
        </BrowserRouter>
      </Provider>
    </AuthWrapper>
  </React.StrictMode>
)
